import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const GAME_ADMIN_EMAIL = "stefanobellisariogenova@gmail.com";

/**
 * Returns true only for the Game admin account (email-based).
 * Source of truth is also enforced server-side via is_game_admin() + RLS.
 */
export function useGameAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!mounted) return;
      const email = (user?.email || "").toLowerCase();
      setIsAdmin(email === GAME_ADMIN_EMAIL);
      setLoading(false);
    };
    check();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      const email = (session?.user?.email || "").toLowerCase();
      setIsAdmin(email === GAME_ADMIN_EMAIL);
    });

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, []);

  return { isAdmin, loading };
}
